import moment from 'moment-timezone';
import { UserDate } from '@shared/services/userDate.service';
import { formatUtcTime } from '@shared/helpers/utils';

export default (value, isConvertToLocale = true) => {
  if (!value) {
    return '';
  }
  const utcValue = formatUtcTime(value);
  const localeTime = isConvertToLocale ? moment.tz(utcValue, UserDate.userTimezone) : moment(value).utc();
  return localeTime.format('YYYY-MM-DD');
};
